/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CountryStayDiem
 */
export interface CountryStayDiem {
    /**
     * 
     * @type {number}
     * @memberof CountryStayDiem
     */
    rate?: number;
    /**
     * 
     * @type {string}
     * @memberof CountryStayDiem
     */
    currency?: string;
}

export function CountryStayDiemFromJSON(json: any): CountryStayDiem {
    return CountryStayDiemFromJSONTyped(json, false);
}

export function CountryStayDiemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryStayDiem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rate': !exists(json, 'rate') ? undefined : json['rate'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
    };
}

export function CountryStayDiemToJSON(value?: CountryStayDiem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rate': value.rate,
        'currency': value.currency,
    };
}


